(() => {
  'use strict';
  if (window.LRSHeaderScroll) return;
  let cleanup = null;
  const root = document.documentElement;

  function init() {
    cleanup?.();
    const header = document.querySelector('.site-header');
    if (!header) return;
    const shell = header.closest('.lrs-header-section');
    if (shell) shell.dataset.headerScrollShell = '';
    const abort = new AbortController();
    const on = (node, event, callback, options = {}) => node.addEventListener(event, callback, {...options, signal:abort.signal});
    let height = 0;
    header.dataset.headerScroll = '';
    header.classList.remove('is-header-hidden');

    // The fixed masthead and every chapter rail share one measured top edge.
    function measure() {
      const fallback = parseFloat(getComputedStyle(root).getPropertyValue('--lrs-header-height')) || 88;
      const nextHeight = Math.ceil(header.getBoundingClientRect().height || header.offsetHeight || fallback);
      if (height === nextHeight) return;
      height = nextHeight;
      root.style.setProperty('--lrs-header-height', `${height}px`);
      root.style.setProperty('--lrs-header-offset', `${height}px`);
      document.dispatchEvent(new CustomEvent('lrs:headerchange', {detail:{height, hidden:false}}));
    }
    on(window, 'resize', measure, {passive:true});
    on(window, 'pageshow', measure);
    on(document, 'shopify:section:select', measure);
    on(document, 'shopify:block:select', measure);
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    resizeObserver?.observe(header);
    measure();
    cleanup = () => {
      abort.abort(); resizeObserver?.disconnect();
      header.classList.remove('is-header-hidden'); delete header.dataset.headerScroll;
      if (shell) delete shell.dataset.headerScrollShell;
      root.style.removeProperty('--lrs-header-height'); root.style.removeProperty('--lrs-header-offset');
      cleanup = null;
    };
  }
  window.LRSHeaderScroll = {init, destroy:() => cleanup?.()};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', event => {if (event.target.querySelector('.site-header')) init();});
  document.addEventListener('shopify:section:unload', event => {if (event.target.querySelector('.site-header')) cleanup?.();});
})();
